import React, { useState } from 'react';
import { X, Loader2, Send } from 'lucide-react';
import { toast } from 'sonner';
import axios from 'axios';

const API = '';

const ContactForm = ({ isOpen, onClose }) => {
  const [form, setForm] = useState({ name: '', email: '', subject: '', message: '' });
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (e) => setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (submitting) return;
    setSubmitting(true);
    try {
      await axios.post(`${API}/api/contact`, form);
      toast.success('Message sent! We\'ll get back to you shortly.');
      setForm({ name: '', email: '', subject: '', message: '' });
      onClose();
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Failed to send message. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center p-4" onClick={onClose}>
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" />
      <div className="relative bg-[var(--bg-surface)] border border-[var(--text-primary)]/10 max-w-md w-full max-h-[90vh] overflow-y-auto"
        onClick={e => e.stopPropagation()} data-testid="contact-form-modal">

        <div className="sticky top-0 z-10 bg-[var(--bg-surface)] border-b border-[var(--text-primary)]/10 px-6 py-4 flex items-center justify-between">
          <h2 className="text-lg font-semibold" style={{ color: 'var(--text-primary)' }}>Contact Us</h2>
          <button onClick={onClose} className="p-1 hover:bg-[var(--text-primary)]/5 rounded transition-colors" data-testid="close-contact-form">
            <X className="w-5 h-5" style={{ color: 'var(--text-secondary)' }} />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          <div>
            <label className="block text-xs font-medium mb-1.5 text-[var(--text-secondary)]">Name *</label>
            <input name="name" type="text" required value={form.name} onChange={handleChange}
              className="input-field w-full" data-testid="contact-name" />
          </div>
          <div>
            <label className="block text-xs font-medium mb-1.5 text-[var(--text-secondary)]">Email *</label>
            <input name="email" type="email" required value={form.email} onChange={handleChange}
              className="input-field w-full" data-testid="contact-email" />
          </div>
          <div>
            <label className="block text-xs font-medium mb-1.5 text-[var(--text-secondary)]">Subject</label>
            <input name="subject" type="text" value={form.subject} onChange={handleChange}
              className="input-field w-full" placeholder="Order inquiry, feedback, etc." data-testid="contact-subject" />
          </div>
          <div>
            <label className="block text-xs font-medium mb-1.5 text-[var(--text-secondary)]">Message *</label>
            <textarea name="message" rows={4} required value={form.message} onChange={handleChange}
              className="input-field w-full resize-none" placeholder="How can we help you?" data-testid="contact-message" />
          </div>
          <button type="submit" disabled={submitting}
            className="btn-primary w-full flex items-center justify-center gap-2"
            data-testid="contact-submit-btn">
            {submitting ? <><Loader2 className="w-4 h-4 animate-spin" /> Sending...</> : <><Send className="w-4 h-4" /> Send Message</>}
          </button>
          <p className="text-[10px] text-center" style={{ color: 'var(--text-muted)' }}>
            Or email us directly at contact@zelinastudios.com
          </p>
        </form>
      </div>
    </div>
  );
};

export default ContactForm;
